<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sr_ascode,sr_custname"
      placeholder="输入维修编码、客户名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.sr_id"
        :to="'/crm/after_sale_repair/'+item.sr_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.sr_code}}</p>
          <p class="list-item-muted">{{item.sr_custname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.sr_urgency}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.sr_status!='已审核'}"
          >{{item.sr_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
    <add-button to="/crm/after_sale_repair_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/afterSaleRepair/list",
      filters: [
        {
          type: "date",
          name: "createTime"
        },
         {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "sr_status_code!='AUDITED'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "sr_status_code='AUDITED'",
            },
          ],
        },
      ]
    };
  }
};
</script>